import React from 'react';
import { twMerge } from 'tailwind-merge';

const NUM_BARS = 5;

const LoadingBar = ({ index, className }: { index: number; className: string }) => (
  <div
    className={twMerge(
      'h-1/2 w-[10%] rounded-[6px] bg-black',
      className,
      index === 0 && 'animate-[loadingBar1_1.25s_infinite_linear_alternate]',
      (index === 1 || index === 3) && 'animate-[loadingBar24_1.25s_infinite_linear_alternate]',
      index === 2 && 'animate-[loadingBar3_1.25s_infinite_linear_alternate]',
      index === 4 && 'animate-[loadingBar5_1.25s_infinite_linear_alternate]',
    )}
  />
);

export const LoadingBars = ({
  height,
  className,
  barClassName,
}: {
  height: number | string | undefined;
  className?: string;
  barClassName?: string;
}) => (
  <div
    style={height ? { height } : undefined}
    className={twMerge('flex aspect-square h-[50px] items-center justify-between', className)}
  >
    {Array.from({ length: NUM_BARS }).map((_, i) => (
      <LoadingBar key={i} index={i} className={barClassName ?? ''} />
    ))}
  </div>
);
